import { validations } from './validations';

/**
 * Questions about beer travel
 */
export const beerTravelQuestions = [
  {
    id: 'beer-travel',
    question: 'Você já fez alguma viagem tendo como principal foco a cerveja? (ex.: Visitar cervejarias, ir a eventos regionais, etc)?',
    type: 'radio',
    options: [
      { value: 'sim, faço sempre que posso', label: 'Sim, faço sempre que posso' },
      { value: 'ja fiz, mas não é recorrente', label: 'Já fiz, mas não é recorrente' },
      { value: 'nunca fiz mas tenho vontade', label: 'Nunca fiz mas tenho vontade' },
      { value: 'nunca fiz e não tenho interesse', label: 'Nunca fiz e não tenho interesse' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'nunca fiz e não tenho interesse' ) {
        return 'beer-travel-no-interest';
      } else if (answer === 'nunca fiz mas tenho vontade') {
        return 'beer-travel-interest';
      }
      return 'beer-travel-already-done';
    },
    validation: validations.required,
  },
  {
    id: 'beer-travel-no-interest',
    question: 'Porque você não tem interesse ou não faz com mais frequência?',
    type: 'checkbox',
    options: [
      { value: 'Custo alto', label: 'Custo alto' },
      { value: 'Nao gosto tanto assim de cerveja', label: 'Não gosto tanto assim de cerveja' },
      { value: 'Nao conheco bem as opcoes de viagens cervejeiras', label: 'Não conheço bem as opções de viagens cervejeiras' },
      { value: 'As pessoas com quem viajo nao tem interesse', label: 'As pessoas com quem viajo não tem interesse' },
      { value: 'não tenho tempo de viajar', label: 'Não tenho tempo de viajar' },
    ],
    allowOther: true,
    nextQuestion: 'beer-content',
    validation: validations.checkboxMinMax(1, 3)
  },
  {
    id: 'beer-travel-already-done',
    question: 'Para onde você já fez viagens cervejeiras?',
    type: 'radio',
    options: [
      { value: 'brasil', label: 'Brasil' },
      { value: 'exterior', label: 'Exterior' },
      { value: 'ambos', label: 'Ambos' },
    ],
    nextQuestion: 'beer-travel-interest',
    validation: validations.required,
  },
  {
    id: 'beer-travel-interest',
    question: 'Para onde você planeja fazer uma viagem cervejeira nos próximos 12 meses?',
    type: 'radio',
    options: [
      { value: 'brasil', label: 'Brasil' },
      { value: 'exterior', label: 'Exterior' },
      { value: 'ambos', label: 'Ambos' },
      { value: 'infelizmente não tenho planos', label: 'Infelizmente não tenho planos' },
    ],
    nextQuestion: 'beer-travel-most-important',
    validation: validations.required,
  },
  {
    id: 'beer-travel-most-important',
    question: 'O que você considera mais importante em uma viagem cervejeira?',
    type: 'checkbox',
    options: [
      { value: 'conhecer cervejas locais', label: 'Conhecer cervejas locais' },
      { value: 'viver uma experiência típica / cultural', label: 'Viver uma experiência típica / cultural' },
      { value: 'visitas à produção', label: 'Visitas à produção' },
      { value: 'experiências diferenciadas / degustações / harmonizações', label: 'Experiências diferenciadas / degustações / harmonizações' },
      { value: 'possibilidade de transfer / não precisar dirigir', label: 'Possibilidade de transfer / não precisar dirigir' },
      { value: 'opções para quem não bebe ou não gosta de cervejas', label: 'Opções para quem não bebe ou não gosta de cervejas' },
      { value: 'provar estilos clássicos na sua origem', label: 'Provar estilos clássicos na sua origem' },
      { value: 'ativações / locais instagramáveis', label: 'Ativações / locais instagramáveis' },
    ],
    allowOther: true,
    nextQuestion: 'beer-content',
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3)
  }
];
